import {
    Chart as ChartJS,
    ArcElement,
    BarElement,
    CategoryScale,
    Legend,
    LinearScale,
    Tooltip,
} from 'chart.js'
import { alpha, chart, chartDefaults } from '../../../ui'

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

// Global Chart.js defaults so every chart shares the dashboard typography.
ChartJS.defaults.font.family = chartDefaults.font.family
ChartJS.defaults.font.size = chartDefaults.font.size
ChartJS.defaults.color = chartDefaults.color
ChartJS.defaults.borderColor = chartDefaults.gridColor
ChartJS.defaults.plugins.tooltip.backgroundColor = chartDefaults.tooltip.backgroundColor
ChartJS.defaults.plugins.tooltip.titleColor = chartDefaults.tooltip.titleColor
ChartJS.defaults.plugins.tooltip.bodyColor = chartDefaults.tooltip.bodyColor
ChartJS.defaults.plugins.tooltip.cornerRadius = chartDefaults.tooltip.cornerRadius
ChartJS.defaults.plugins.tooltip.padding = chartDefaults.tooltip.padding

/** Ordered series palette from the design tokens (see src/ui/tokens.ts). */
export const brandPalette: readonly string[] = chart.series

export const brandPaletteAlpha = (a: number) => brandPalette.map((hex) => alpha(hex, a))

export const formatCurrencyGBP = (value: number) =>
    new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
    }).format(value || 0)

export const formatNumberGBP = (value: number) =>
    new Intl.NumberFormat('en-GB').format(value || 0)
